import {motion} from "framer-motion";

const AnimatedLightning = () => {
    return (
        <motion.svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="url(#grad)"       // Stroke uses the gradient defined below
            strokeWidth="1.2"         // Line thickness
            strokeLinecap="butt"      // Shape of line endings
            strokeLinejoin="miter"    // Shape of line joins (sharp corners)
            className="
        rounded-xl
        w-40 h-40
        sm:w-56 sm:h-56
        md:w-72 md:h-72
        lg:w-[500px] lg:h-[500px]
    "
        >
            {/* ---------- Gradient Definition ---------- */}
            <defs>
                {/* Linear gradient for stroke color (orange → blue) */}
                <linearGradient id="grad" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="orange"/>
                    <stop offset="100%" stopColor="blue"/>
                </linearGradient>

                {/* Glow filter to give the path a glowing effect */}
                <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
                    {/* Drop shadow used as glow (pinkish/red glow) */}
                    <feDropShadow dx="0" dy="0" stdDeviation="2" floodColor="#FF6B6B"/>
                </filter>
            </defs>

            {/* ---------- Lightning Path with Animation ---------- */}
            <motion.path
                d="M13 2 L3 14 H11 L9 22 L21 10 H13 Z" // SVG path that shapes the lightning bolt
                initial={{pathLength: 0}}
                animate={{pathLength: 1}}
                transition={{
                    duration: 2,                        // Take 2s to draw
                    repeat: Infinity,                   // Loop forever
                    repeatType: "reverse",              // Reverse (draw → erase → draw...)
                    ease: "easeInOut",                  // Smooth acceleration and deceleration
                }}
                filter="url(#glow)"                     // Apply glow filter
            />
        </motion.svg>
    );
};

export default AnimatedLightning;
